import { ACCLOADING } from "../actions/types"

const initialize = {accLoading: false}
const accLoadingReducer = (state = initialize, action) => {
    switch (action.type) {
        case ACCLOADING.FETCH:
            return {accLoading: true}
        
        case ACCLOADING.FINISH:
            return {accLoading: false}
    
        default:
            return state
    }
}

export default accLoadingReducer